import axios from "axios";
import {theme_info} from './theme.js';

function GetParams(device_id, queue)
{
    let params = "?device_id=" + device_id;
    if (queue)
        params += "&queue=1"
    return params;
}

export function AddGreeting(device_id, name, template_id, queue)
{
    let template = theme_info("templates")[template_id];
    return axios("/api/greeting" + GetParams(device_id, queue) + "&name=" + name + "&css_file=" + template.css_file + "&img_file=" + template.img_file + "&thumb_url=" + encodeURIComponent(template.thumb_url));
}

export function AddRenderURL(device_id, url, queue)
{
    return axios("/api/render_url" + GetParams(device_id, queue) + "&url=" + encodeURIComponent(url));
}

export function AddImagine(device_id, prompt, images_to_generate, queue)
{
    return axios("/api/imagine" + GetParams(device_id, queue) + "&prompt=" + prompt + "&image_count=" + images_to_generate);
}

export function GetImaginePreview(device_id, prompt)
{
    return axios("/api/imagine" + GetParams(device_id) + "&prompt=" + prompt + "&preview=1");
}

export function AddClear(device_id, queue)
{
    return axios("/api/clear" + GetParams(device_id, queue));
}

export function RemovePlaylistItemByID(device_id, id)
{
    return axios("/api/delete_playlist_item" + GetParams(device_id) + "&id=" + id);
}

export function SetPlaylistItemConfigByID(device_id, id, config)
{
    return axios.post("/api/set_playlist_item_config" + GetParams(device_id) + "&id=" + id, config);
}

export function AddUpload(device_id, file, queue)
{
    const formData = new FormData();
    formData.append('files', file);

    return fetch(
        '/api/upload' + GetParams(device_id, queue),
        {
            method: 'POST',
            body: formData,
        }
    )
    
}

export function GetDeviceDetails(device_id)
{
    return axios("/api/get_device_details" +  GetParams(device_id))
}

export function SetDeviceConfig(device_id, config)
{
    return axios.post("/api/set_config" +  GetParams(device_id), config)
}

export function DeleteImage(device_id, image_collection, image_id)
{
    return axios.get("/api/delete_image" +  GetParams(device_id) + "&image_collection=" + image_collection + "&image_id=" + image_id)
}

export function AddFromImageCache(device_id, image_collection, image_id, queue)
{
    return axios.get("/api/from_image_cache" +  GetParams(device_id, queue) + "&image_collection=" + image_collection + "&image_id=" + image_id)
}

export function TimeFormat24To12(time_24_hours)
{
    let time_elems = time_24_hours.split(":")
    let hour = parseInt(time_elems[0]);
    let time_str = null;
    if (hour>=12) {
        if (hour == 12)
            hour += 12;
        time_str = hour-12 + ":" + time_elems[1] + "PM";
    } else
        time_str = hour + ":" + time_elems[1] + "AM"; 
    return time_str;
}

export function GetUpdateIntervalMinutes(update_times_24_hrs)
{
    if (update_times_24_hrs.length == 1 && update_times_24_hrs[0] == "3:00")
        return 24*60
    else if (update_times_24_hrs.length == 2 && update_times_24_hrs[0] == "3:00" && update_times_24_hrs[1] == "15:00")
        return 12 * 60
    else if (update_times_24_hrs.length == 4 && update_times_24_hrs[0] == "3:00" && update_times_24_hrs[1] == "10:00" && update_times_24_hrs[2] == "16:00" && update_times_24_hrs[3] == "22:00")
        return 6*60
    else {
        let custom_schedule_from = parseInt(update_times_24_hrs[0].split(":")[0])

        if (update_times_24_hrs[1].split(":")[1] == "01") {
            return 1;      
        } else if (update_times_24_hrs[1].split(":")[1] == "02") {
            return 2;
        } else if (update_times_24_hrs[1].split(":")[1] == "05") {
            return 5;
        } else if (update_times_24_hrs[1].split(":")[1] == "10") {
            return 10;
        } else if (update_times_24_hrs[1].split(":")[1] == "15") {
            return 15;
        } else if (update_times_24_hrs[1].split(":")[1] == "30") {
            return 30;
        } else { 
            let next_hour = parseInt(update_times_24_hrs[1].split(":")[0])
            if (next_hour - custom_schedule_from == 1)
                return 60;
            else if (next_hour - custom_schedule_from == 2)
                return 2*60;
            else    
                return 4*60;
        }
    }

}

function awaitImageChange(device_id, current_image_url, resolve, reject)
{
    GetDeviceDetails(device_id).then((res) => {

        if (res.data.status != "Active")
            resolve(res.data.status);
        else if (current_image_url == res.data.current_image_url)
            setTimeout(()=>{awaitImageChange(device_id, current_image_url, resolve, reject)}, 3000);
        else
            resolve(res.data.status)

    }).catch((err) => {
        reject()
    });

}

export function AwaitImageChange(device_id, current_image_url)
{
    return new Promise((resolve,reject) => {
        setTimeout(()=>{awaitImageChange(device_id, current_image_url, resolve, reject)}, 3000);
    });
    
}